import store from '../'

let resource = store.defineResource({
  name: "responses",
  relations: {
    belongsTo: {
      questions: {
        localField: "question",
        localKey: "questionId"
      },
      userAssignments: {
        localField: "userAssigment",
        localKey: "userAssignmentId",
        parent: true
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/responses.js